'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$12() {
  this.beB = null;
  this.bez = null;
  this.beA = false;
  this.bex = null;
  this.bey = false;
  this.beC = false;
  this.beD = false;
  this.beB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$12 as $c_Lpresto_PrestoRouter$$anon$12 };
$p = $c_Lpresto_PrestoRouter$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$12;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$12() {
}
export { $h_Lpresto_PrestoRouter$$anon$12 as $h_Lpresto_PrestoRouter$$anon$12 };
$h_Lpresto_PrestoRouter$$anon$12.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.beB;
});
$p.t = (function() {
  if ((!this.beA)) {
    this.bez = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.beA = true;
  }
  return this.bez;
});
$p.ae = (function() {
  if ((!this.bey)) {
    this.bex = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gJ()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bey = true;
  }
  return this.bex;
});
$p.w = (function() {
  if ((!this.beD)) {
    this.beC = false;
    this.beD = true;
  }
  return this.beC;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$12, "presto.PrestoRouter$$anon$12", ({
  NB: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$12 as $d_Lpresto_PrestoRouter$$anon$12 };
//# sourceMappingURL=presto.-Presto-Router$$anon$12.js.map
